/**
 * Origin of the image service (the Cloudflare Worker in `images-worker/`, R2 behind it).
 * Uploads (`/upload`), stored images (`/image/*`) and site icons (`/favicon/{host}`) are all
 * served from here, so the origin is written once. Not in `config/api.ts`: that file is the
 * backend API's configuration and reads the platform at import time.
 */
export const IMAGE_SERVICE_ORIGIN = 'https://stdio.meetball.fun';
